import { IMAGE_TYPE, getPublicUrl, getUploadImageUrl } from '../../helpers/url'

import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import axios from 'axios'
import config from '../../config'
import moment from 'moment'

export const updateHighlightSeriesDetail = async (formData) => {
  const body = {
    sizes: formData.size.split(','),
    title: formData.title,
    headerImage: formData.headerImage,
    description: formData.description,
    start: new Date(formData.start).toISOString(),
    end: new Date(formData.end).toISOString(),
    showCountdown: formData.showCountdown,
  }
  await axios.patch(`${config.apiAdminGateway}/api/v1/admin/configs/highlightSeriesDetail`, body, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  })
}

export const getSummaryHTML = ({
  start,
  end,
  size,
  description,
  title,
  headerImage,
  showCountdown,
  minutesToClose,
}) => {
  const startTime = moment(start).format('DD/MM/YYYY HH:mm')
  const endTime = moment(end).format('DD/MM/YYYY HH:mm')
  const showCountdownText = showCountdown ? 'แสดง' : 'ไม่แสดง'

  const sizes = size.split(',').map((value) => `${value} ใบ`)
  const countdownColor = showCountdown ? 'green' : 'red'

  const html = `
      <div>ชุด: ${sizes.join(', ')}</div>
      <div>
        <span>หัวข้อ: </span>
        <strong>${headerImage ? '(แสดงรูปภาพ)' : title}</strong>
      </div>
      <div>
        <span>คำอธิบาย: </span>
        <strong>${description}</strong>
      </div>
      <div>เวลาเริ่มขาย: ${startTime}</div>
      <div>เวลาหยุดขาย: ${endTime}</div>
      <div>เป็นระยะเวลา: ${minutesToClose} นาที</div>
      <div>แสดงเวลาขาย: <span style="color:${countdownColor}">${showCountdownText}</span></div>
    `

  return html
}

export const fireInfoModal = (key) => {
  switch (key) {
    case 'size':
      Swal.fire({
        icon: 'info',
        title: 'ตัวอย่างการกรอกข้อมูล',
        html: '<div><h2>กรอกขนาดชุด</h2> <p>กรอก <b>5</b> หมายถึง ชุดที่มี <b>5</b> ใบ</p> <div>กรอกขนาดชุดเว้นด้วยลูกน้ำ (,)</div> <p>เช่น <b>2,3,10</b> หมายถึง ชุด <b>2</b> ใบ, ชุด <b>3</b> ใบ, ชุด <b>10</b> ใบ</p> </div>',
      })
      break

    case 'title':
      Swal.fire({
        icon: 'info',
        title: 'ตัวอย่างการกรอกข้อมูล',
        html: `<div>
          <p>กรอกคำอธิบายที่จะแสดงแทนรูปภาพในหน้าเว็บไซต์</p>
          <b style="color:red">หากมีรูปภาพ ข้อความส่วนนี้จะไม่แสดง</b>
          </div>`,
      })
      break

    case 'headerImage':
      Swal.fire({
        icon: 'info',
        title: 'ตัวอย่างการกรอกข้อมูล',
        text: 'อัปโหลดรูปภาพที่จะแสดงในหน้าเว็บไซต์',
      })
      break

    case 'description':
      Swal.fire({
        icon: 'info',
        title: 'ตัวอย่างการกรอกข้อมูล',
        text: 'กรอกคำอธิบายที่จะแสดงใต้รูปภาพหรือหัวข้อ ในหน้าเว็บไซต์',
      })
      break

    default:
      break
  }
}

export const uploadImage = async (file) => {
  const url = await getUploadImageUrl(IMAGE_TYPE.PNG)
  const imageUrl = getPublicUrl(url)

  const response = await fetch(url, {
    method: 'PUT',
    body: file,
  })

  if (!response.ok) throw new Error('Error uploading image')

  return imageUrl
}

export const arrayOfIntegers = (str) => {
  let setOfIntegers = new Set()

  let numericValues = str.match(/\d+/g)

  if (numericValues) {
    numericValues.forEach(function (item) {
      let intValue = parseInt(item)
      setOfIntegers.add(intValue)
    })
  }
  return Array.from(setOfIntegers)
}

export async function getImageWidth(file) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = URL.createObjectURL(file)
    image.onload = function () {
      resolve(image.width)
    }
    image.onerror = function (error) {
      reject(error)
    }
  })
}

export async function blobToFile(blob, fileName) {
  blob.lastModifiedDate = new Date()
  blob.name = fileName
  return blob
}
